(() => {
  const init = () => {
    const h = document.querySelector('[data-ag-header]'); if (!h || h.dataset.ready) return; h.dataset.ready = '1';
    const burger = h.querySelector('[data-ag-burger]'); const drawer = h.querySelector('[data-ag-drawer]');
    const setOpen = (open) => {
      h.classList.toggle('is-open', open); burger.setAttribute('aria-expanded', String(open));
      drawer.hidden = !open; document.documentElement.style.overflow = open ? 'hidden' : '';
      // Le dock « Commencer » se retire pendant que le menu est ouvert (voir ag-dynamic.css)
      document.documentElement.classList.toggle('ag-menu-open', open);
      if (open) drawer.querySelector('a')?.focus({ preventScroll: true }); else burger.focus({ preventScroll: true });
    };
    burger?.addEventListener('click', () => setOpen(!h.classList.contains('is-open')));
    drawer?.querySelectorAll('[data-ag-close]').forEach(el => el.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && h.classList.contains('is-open')) setOpen(false); });

    // Barre qui se transforme au défilement : seuils différents à la descente et à la remontée (pas de clignotement), calcul limité à 1 par image
    let scrolled = false, ticking = false;
    const update = () => { ticking = false; const y = window.scrollY;
      const next = scrolled ? y > 12 : y > 36; if (next !== scrolled) { scrolled = next; h.classList.toggle('is-scrolled', scrolled); } };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
